import { Group, Member } from '../../../../../api/groups';
import ListGroup from './students-content/ListGroup';
import ListGroupSmartschool from './students-content/ListGroupSmartschool';

type Props = {
  group: Group;
  members: Member[];
};

function StudentsContent({ group, members }: Props) {
  const isSmartschool = group.school.isSmartschool;

  return (
    <>
      {isSmartschool ? (
        <ListGroupSmartschool group={group} members={members} />
      ) : (
        <ListGroup group={group} members={members} />
      )}
    </>
  );
}

export default StudentsContent;
